/* eslint-disable react/style-prop-object */
import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useState, useEffect } from "react";
import { Select } from "antd";
import Button from "../../../../../../Helpers/Button/Button";
import {
	useGetAllGeofencesQuery,
	useGetGeofencesByDeviceQuery,
} from "../../../../../../../Redux/service/Geofences/Geofences";
import Close from "../../../../../../Helpers/CloseBtn/Close";
import {
	useAddPermissionMutation,
	useDeletePermissionMutation,
} from "../../../../../../../Redux/service/Permissions/Permissions";
import { toast } from "react-toastify";
import trans from "../../../../../../../utils";

const SetGeofence = ({
	title,
	device,
	setControlsPopup,
	setIsControlsPopup,
}) => {
	const [selectedGeofence, setSelectedGeofence] = useState([]);
	const { data: allGeofences = [], refetch: refetchAllGeofences } =
		useGetAllGeofencesQuery();
	const { data: initialSelected = [], refetch: refetchSelectedGeofences } =
		useGetGeofencesByDeviceQuery(device?.id, { skip: !device?.id });

	const [alreadySelected, setAlreadySelected] = useState([]);
	const [addPermission, { isLoading }] = useAddPermissionMutation();
	const [deletePermission] = useDeletePermissionMutation();
	const [loading, setLoading] = useState(false);
	const [hasChanges, setHasChanges] = useState(false);

	useEffect(() => {
		refetchAllGeofences();
		refetchSelectedGeofences();
	}, [title]);

	useEffect(() => {
		const initialIds = initialSelected
			.map((geo) => geo?.id)
			.sort()
			.join(",");
		const selectedIds = selectedGeofence.slice().sort().join(",");
		setHasChanges(initialIds !== selectedIds);
	}, [selectedGeofence, initialSelected]);

	useEffect(() => {
		if (initialSelected?.length > 0) {
			setAlreadySelected(initialSelected);
			setSelectedGeofence(initialSelected.map((geo) => geo?.id));
		}
	}, [initialSelected]);

	const formik = useFormik({
		initialValues: { deviceId: device?.id, geofenceId: [] },
		validationSchema: Yup.object({
			geofenceId: Yup.array().required(
				trans("At least one Geofence is required"),
			),
		}),
		onSubmit: async () => {
			setLoading(true);
			try {
				for (const id of selectedGeofence) {
					const body = { deviceId: device?.id, geofenceId: id };
					await addPermission(body).unwrap();
				}
				await refetchSelectedGeofences();
				toast.success(trans("New Geofence Is linked to device"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar",
				});
				setControlsPopup("");
				setIsControlsPopup(false);
			} catch (error) {
				toast.error(
					trans("Error linking the Geofence to device, please try again later"),
					{
						autoClose: 800,
						rtl: localStorage.getItem("lang") === "ar",
					},
				);
			} finally {
				setLoading(false);
			}
		},
	});

	useEffect(() => {
		formik.setFieldValue("geofenceId", selectedGeofence);
	}, [selectedGeofence]);

	const handleChange = async (values) => {
		const added = values.filter((id) => !selectedGeofence.includes(id));
		const removed = selectedGeofence.filter((id) => !values.includes(id));

		let addFailed = false;
		let deleteFailed = false;

		// ADD geofences
		for (const id of added) {
			try {
				await addPermission({
					deviceId: device?.id,
					geofenceId: id,
				}).unwrap();
				toast.success(trans("New Geofence Is linked to device"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar",
				});
			} catch {
				addFailed = true;
			}
		}

		// REMOVE geofences
		for (const id of removed) {
			try {
				await deletePermission({
					deviceId: device?.id,
					geofenceId: id,
				}).unwrap();
				toast.success(trans("Geofence is unlinked from vehicle successfully"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar",
				});
			} catch {
				deleteFailed = true;
			}
		}

		if (addFailed) {
			toast.error(
				trans("Error linking the Geofence to device, please try again later"),
				{
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar",
				},
			);
		}

		if (deleteFailed) {
			toast.error(
				trans(
					"Error unlinking the Geofence from device, please try again later",
				),
				{
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar",
				},
			);
		}

		// Update UI only if nothing failed
		if (!addFailed && !deleteFailed) {
			setSelectedGeofence(values);
		}
	};

	if (title !== "set geofence") return null;

	return (
		<form onSubmit={formik.handleSubmit}>
			<div className="pb-3">
				<Select
					mode="multiple"
					maxTagCount={"responsive"}
					style={{ width: "100%", marginTop: 12 }}
					placeholder={trans("Select Geofences")}
					value={selectedGeofence}
					onChange={handleChange}
					options={allGeofences.map((geo) => ({
						value: geo?.id,
						label: geo.name,
					}))}
					filterOption={(input, option) =>
						option.label.toLowerCase().includes(input.toLowerCase())
					}
				/>

				{/* <div className="w-100 flex-row justify-end mt-12">
					<Button
						text={trans("Save")}
						htmlType="submit"
						type="primary"
						loading={loading}
						disabled={!hasChanges}
					/>
				</div> */}
			</div>
		</form>
	);
};

export default SetGeofence;
